import { Component } from 'react';
import { isTrue } from '../../../../helpers/isTrue';
import ConfirmationModal from '../../../../components/Modals/ConfirmationModal';

class Plan extends Component {
    constructor() {
        super();
        this.license = window.license ?? {};
        this.reactivate = this.reactivate.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);

        this.is_not_viewer = window.is_not_viewer;
        this.state = {
            disableBtn: false,
            isOpen: false,
            sub_status: '',
            statusExist: false,
        };
    }

    async componentDidMount() {
        try {
            const res = await fetch('/customers/account-status/', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': '{{csrf_token}}',
                },
            });
            const data = await res.json();
            this.setState({
                statusExist: true,
                sub_status: data?.sub_status,
            });
        } catch (err) {
            console.log(err);
        }
    }

    async reactivate() {
        try {
            this.setState({
                disableBtn: true,
            });
            const link = `/customers/licenses/${this.license.license_id}/reactivate/`;
            await fetch(link);
            window.location.reload();
        } catch (err) {
            window.location.reload();
        }
    }

    async deactivate() {
        const link = document.createElement('a');
        link.href = `/customers/user-cancellation/${this.license.license_id}/`;
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    onOpenModal() {
        this.setState({ isOpen: true });
    }

    onCloseModal() {
        this.setState({ isOpen: false });
    }

    render() {
        const message = (
            <div>
                <div className="mb-10">
                    Are you sure you want to cancel your trial subscription?
                </div>
                <div className="mb-10">
                    Cancelling now will{' '}
                    <strong>stop all data collection and google Discover analysis.</strong>
                </div>
                <div className="mb-10">
                    You will <strong>no longer be able to access your report </strong>once account
                    is cancelled.
                </div>
                Would you like to continue?
            </div>
        );
        return (
            <>
                <div className="settings-plan">
                    <div className="settings-plan-header">
                        <div className="settings-plan-header-title">Current Plan</div>
                        {this.is_not_viewer && this.license?.license_id && (
                            <div className="settings-plan-header-btns">
                                <a
                                    className="settings-secondary-btn"
                                    href={`/customers/licenses/${this.license.license_id}`}
                                >
                                    Billing History
                                </a>
                                {isTrue(this.props.is_deactivated) ? (
                                    <>
                                        <a
                                            className="settings-secondary-btn"
                                            href="/customers/change_plan/"
                                        >
                                            Reactivate
                                        </a>
                                        {this.props.customer_id !== 'False' && (
                                            <a
                                                className="settings-secondary-btn"
                                                href={`/settings/payment-methods/${this.props.customer_id}`}
                                            >
                                                Payment Methods
                                            </a>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <a
                                            className="settings-secondary-btn"
                                            href="#"
                                            role="button"
                                            id="dropdownMenuLink"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <button className="btn-icon d-flex">
                                                <i className="icon-settings1"></i>
                                            </button>
                                        </a>
                                        <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuLink"
                                        >
                                            {isTrue(this.props.cancel_at_period_end) ? (
                                                <li>
                                                    <button
                                                        className="dropdown-item"
                                                        disabled={this.state.disableBtn}
                                                        onClick={this.reactivate}
                                                    >
                                                        Reactivate
                                                    </button>
                                                </li>
                                            ) : (
                                                this.state.statusExist && (
                                                    <li>
                                                        {this.state.sub_status === 'trialing' ? (
                                                            <a
                                                                className="dropdown-item cursor-pointer"
                                                                onClick={this.onOpenModal}
                                                            >
                                                                Deactivate
                                                            </a>
                                                        ) : (
                                                            <a
                                                                className="dropdown-item cursor-pointer"
                                                                href={`/customers/user-cancellation/${this.license.license_id}/`}
                                                            >
                                                                Deactivate
                                                            </a>
                                                        )}
                                                    </li>
                                                )
                                            )}
                                            <li>
                                                <a
                                                    className="dropdown-item"
                                                    href={`/customers/change_plan/${this.license.license_id}`}
                                                >
                                                    Change Plan
                                                </a>
                                            </li>
                                        </ul>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="settings-plan-content">
                        {this.license.license_id ? (
                            <>
                                <div className="settings-plan-content-left">
                                    <div className="settings-plan-content-left-header">
                                        {this.license.license_product_name}
                                        <div className="settings-plan-content-left-tag">
                                            {this.license.tag_1}
                                        </div>
                                        <div className="settings-plan-content-left-tag">
                                            {this.license.tag_2}
                                        </div>
                                    </div>
                                    {isTrue(this.props.cancel_at_period_end) && (
                                        <div className="settings-plan-content-left-bottom">
                                            Your account will be active until{' '}
                                            <span>{this.props.cancel_in}</span>
                                        </div>
                                    )}
                                </div>
                                {isTrue(this.props.cancel_at_period_end) && (
                                    <div className="settings-plan-content-right">
                                        <button
                                            className="button button-filled button-primary"
                                            disabled={this.state.disableBtn}
                                            onClick={this.reactivate}
                                        >
                                            Reactivate Your Account
                                        </button>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="settings-plan-content-left-bottom">
                                {' '}
                                You currently have no licenses.
                            </div>
                        )}
                    </div>
                </div>
                <ConfirmationModal
                    isOpen={this.state.isOpen}
                    message={message}
                    onClose={this.onCloseModal}
                    onSubmit={this.deactivate}
                    cancleBtn="No, Keep My Trial"
                    buttonName="Yes, Cancel My Trial"
                />
            </>
        );
    }
}

export default Plan;
